export default __webpack_public_path__ + "static/835-ec2996fdb97cd7534c9866ecb438464e.gif";